<template>
  <div class="rds-menu-container">
    <div class="rds-menu-overlay" v-on:tap.self="onClickOutside"></div>
    <div class="rds-menu-content">
      <div class="rds-menu">
        <div class="user-info">
          <div
            class="user-img-container"
            v-bind:class="{google : userService.user.photos[0].indexOf('googleusercontent')!==-1}"
          >
            <img v-bind:src="userService.user.photos[0]" alt="userService.user.name" />
          </div>
          <div class="user-name">{{ userService.user.name }}</div>
          <div class="user-role">{{ userService.user.info.role}}</div>
        </div>
        <div class="actions">
          <ul>
            <li class="action">
              <RdsFileUploader v-on:fileUploaded="onFileUploaded"></RdsFileUploader>
              <span class="action-icon">
                <IconChangeImage />
              </span>
              <span>Cambia immagine</span>
            </li>
            <li class="action" v-on:tap="goTo('/profile/edit')">
              <span class="action-icon">
                <IconEditProfile />
              </span>
              <span>Modifica profilo</span>
            </li>
            <li class="action" v-on:tap="onClickProducts">
              <span class="action-icon">
                <IconArticoli />
              </span>
              <span>Articoli in vendita</span>
            </li>
            <li class="action" v-on:tap="toggleNotifications">
              <span class="action-icon">
                <IconNotifiche />
              </span>
              <span>Notifiche</span>
            </li>
          </ul>
        </div>
        <div class="footer-actions">
          <div class="action" v-on:tap="logout">
            <span class="action-icon">
              <IconLogout />
            </span>
            <span>Logout</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import userService from '../services/User.service';
import IconArticoli from '../assets/images/menu-profilo/articoli_in_vendita.svg?inline';
import IconChangeImage from '../assets/images/menu-profilo/cambia_immagine.svg?inline';
// import IconInfo from '../assets/images/menu-profilo/info_icon.svg?inline';
import IconLogout from '../assets/images/menu-profilo/Logout.svg?inline';
import IconEditProfile from '../assets/images/menu-profilo/modifica_profilo.svg?inline';
import IconNotifiche from '../assets/images/menu-profilo/notifiche.svg?inline';
import { eventBus } from '../services/EventBus';
import RdsFileUploader from '../components/RdsFileUploader';
import memoryStore from '../stores/MemoryStore';
export default {
  name: 'RdsMenu',
  components: {
    IconArticoli,
    IconChangeImage,
    IconLogout,
    IconEditProfile,
    IconNotifiche,
    RdsFileUploader
  },
  data() {
    return {
      userService: userService
    };
  },
  methods: {
    toggleNotifications() {
      eventBus.$emit('hideMenuProfile');
      eventBus.$emit('toggleNotifications');
    },
    onClickOutside() {
      eventBus.$emit('hideMenuProfile');
    },
    onClickProducts() {
      this.goTo('/market?user=' + this.userService.user.id);
    },
    onFileUploaded(file) {
      // if (this.$route.name === 'editImage' || this.$route.name === 'home') {
      //   eventBus.$emit('hideMenuProfile');
      //   eventBus.$emit('editMode', file);
      // }
      memoryStore.editableImage = file;
      console.log('SET memoryStore.editableImage');

      this.goTo('/edit-image');
    },
    goTo(route) {
      eventBus.$emit('hideMenuProfile');
      this.$router.push(route);
    },
    logout() {
      userService.logout();
      this.$router.push('/login');
    }
  }
};
</script>
<style lang="scss" scoped>
.rds-menu-container,
.rds-menu-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 3;
}
.rds-menu-container {
  height: calc(100% - 62px);
  top: 62px;
}
.rds-menu-overlay {
  opacity: 0.7;
  background-color: #ffffff;
}
.menu-slide-right-leave-to .rds-menu-overlay,
.menu-slide-right-enter-to .rds-menu-overlay {
  opacity: 0;
}
.rds-menu-content {
  height: 100%;
  width: 75%;
  position: absolute;
  background-image: url('../assets/images/menu-profilo/Background_menu_profilo_home.svg');
  // background-size: cover;
  z-index: 3;
  background-size: 151% auto;
  background-position: -73px -80px;
  background-repeat: no-repeat;
}
.rds-menu {
  height: calc(100% - (44px * 2));
  width: calc(100% - (37px * 2));
  top: 0;
  left: 0;
  // background-color: #1d2e90;
  // background-image: url('../assets/images/menu-profilo/Background_menu_profilo_home.svg');
  position: relative;
  color: #ffffff;
  padding: 44px 37px;
  letter-spacing: $default-letter-spacing;
}
.actions,
.footer-actions {
  font-weight: 400;

  .action {
    padding: 16px;
    margin: 0 -16px;
    position: relative;
    display: flex;
    align-self: center;
  }
  .action-icon {
    width: 24px;
    padding-right: 13px;
  }
}
.user-info {
  margin-bottom: 65px;
}
.user-name {
  font-size: 1.1em;
  line-height: 1.5em;
  padding: 8px 0;
}
.user-role {
  font-size: 0.87em;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.56);
}
.user-img-container {
  width: 82px;
  max-width: none;
  overflow: hidden;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  img {
    height: 82px;
    max-width: none;
    position: relative;
    right: 50%;
  }
}
.google.user-img-container {
  img {
    border-radius: 50%;
    width: 100%;
    position: inherit;
  }
}
</style>
